import {
  Form,
  Button,
  Select,
  Input,
  Table,
  Checkbox,
  Row,
  Col,
  Radio,
  Modal,
} from "antd";
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons'
import {
  GET_SP_AGREEMENT_DATA,
  GET_SP_AUTO_ADVISE,
  GET_PORTFOLIO_BETA,
  NON_INDIVIDUAL_AGREEMENT_MAIL_SEND,
  GET_USER_ADDONS,
  GET_USERS_BY_PAN_CARD,
  GET_KYC,
} from './graphql/Queries'
import React, { useContext, useEffect, useState } from 'react'
import { get } from 'lodash'

import "./verification.css";
import { GET_PLANS_BASED_POINTS } from "modules/Questionnaires/graphql/Query";
import { GET_PLAN } from "modules/Plans/graphql/Query";
import {
  COMPLETE_STEP,
  INVESTMENT_PLANNING_MAIL,
  CREATE_USER_FROM_PARENT,
  UPLOAD_PORTFOLIO_BETA_FILE,
} from "./graphql/Mutations";
import { UPDATE_USER } from "modules/Users/graphql/Mutations";
import openNotification from "utils/Notification";
import { useQuery } from "@apollo/react-hooks";
import CustomMeta from "components/CustomMeta";
import Page404 from "components/Page404";
import { AppContext } from "AppContext";
import client from "apollo";
import { GET_MAX_EXPOSURE, GET_NIFTY } from "modules/Reports/graphql/Queries";
import { GENERATE_NON_INDIVIDUAL_REPORT } from "modules/Settings/graphql/Queries";
import {
  convertNumberToCommaSeparate,
  formatToLakhsOrCrores,
  numberToWord,
} from "utils/utilities";
import RightArrowIconWhite from "assets/images/new-images/right-arrow-white.svg";
import KeyInfo from "./KeyInfo";
import { GET_USER } from "modules/Users/graphql/Queries";
import {
  isPortfolioBetaProduct,
  isFinsaverProduct,
  PORTFOLIO_BETA_DISPLAY_LABEL,
  PORTFOLIO_BETA_STRATEGY_CODE,
} from "./productOptions";

const FormItem = Form.Item;
const { Option } = Select;

const normalizePortfolioKey = (value = "") =>
  value.toString().replace(/[^a-z0-9]/gi, "").toLowerCase();

const findPortfolioValue = (record = {}, keyMatchers = []) => {
  const entries = Object.entries(record || {});

  for (const [key, value] of entries) {
    const normalizedKey = normalizePortfolioKey(key);
    if (keyMatchers.some((matcher) => normalizedKey.includes(matcher))) {
      return value;
    }
  }

  return undefined;
};

const getPortfolioSummary = (rows = []) => {
  const summaryRow =
    rows.find((row) => {
      return (
        findPortfolioValue(row, ["portfoliobeta"]) !== undefined ||
        findPortfolioValue(row, ["totalvalue", "portfoliovalue"]) !==
        undefined ||
        findPortfolioValue(row, ["hedgingcost", "hedgecost"]) !== undefined ||
        row?.FinalExposure !== undefined ||
        row?.HedgeCost !== undefined
      );
    }) || rows[0] || {};

  return {
    portfolioBeta: findPortfolioValue(summaryRow, [
      "portfoliobeta",
      "betavalue",
      "beta",
    ]),
    totalValue:
      summaryRow?.FinalExposure !== undefined
        ? summaryRow.FinalExposure
        : findPortfolioValue(summaryRow, ["totalvalue", "portfoliovalue"]),
    hedgingCost:
      summaryRow?.HedgeCost !== undefined
        ? summaryRow.HedgeCost
        : summaryRow?.HedgingCost !== undefined
          ? summaryRow.HedgingCost
          : findPortfolioValue(summaryRow, ["hedgingcost", "hedgecost"]),
    hedgingCostPer:
      summaryRow?.HedgeCostper !== undefined
        ? summaryRow.HedgeCostper
        : summaryRow?.A_Aper !== undefined
          ? summaryRow.A_Aper
          : findPortfolioValue(summaryRow, ["hedgingcostper", "a_aper"]),
  };
};

const getPortfolioHoldingRows = (rows = []) =>
  rows.filter((row) => {
    const normalizedKeys = Object.keys(row || {}).map(normalizePortfolioKey);

    return normalizedKeys.some(
      (key) =>
        key.includes("isin") ||
        key.includes("symbol") ||
        key.includes("qty") ||
        key.includes("quantity") ||
        key.includes("price") ||
        key.includes("exchange")
    );
  });

const formatPortfolioColumnTitle = (key) =>
  key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .toUpperCase();

const formatPortfolioCell = (value, columnKey) => {
  if (value === null || value === undefined || value === "") return "-";

  const normalizedKey = normalizePortfolioKey(columnKey);

  if (normalizedKey.includes("beta")) {
    const numericValue = Number(value);
    return Number.isNaN(numericValue) ? value : numericValue.toFixed(3);
  }

  if (
    typeof value === "number" ||
    (typeof value === "string" &&
      value.trim() !== "" &&
      !Number.isNaN(Number(value.replaceAll(",", ""))) &&
      !normalizedKey.includes("isin"))
  ) {
    return convertNumberToCommaSeparate(
      Number(value.toString().replaceAll(",", "")),
      false
    );
  }

  return value;
};

const parsePortfolioNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const numericValue = Number(value.toString().replaceAll(",", "").trim());

  return Number.isNaN(numericValue) ? null : numericValue;
};

const getPortfolioFileKey = (file = {}) =>
  [file?.name, file?.size, file?.lastModified].join("-");

const InvestmentPlanningNew = ({ next, back, newEdit }) => {
  const {
    state: { isMobile, currentUser },
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const { dispatch, state } = useContext(AppContext);
  const {
    id,
    annualIncome,
    clientScore,
    initialInvestment,
    entityStatus,
    isPanCardIndividual,
    isNewAuaAdvisoryGenerate,
    completedSteps,
  } = state.currentUser;
  const { niftyLotSize } = state.generalSetting;
  let { clientSummaryDetails } = state;
  const [reviewPlanData, setReviewPlanData] = useState(undefined);
  const [agree, setAgree] = useState(true);
  const [loader, setLoader] = useState(false);
  const [planLoader, setPlanLoader] = useState(false);
  const [exposureValue, setExposureValue] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState();
  const [selectedPlanType, setSelectedPlanType] = useState("active");
  const [selectedNewPlan, setSelectedNewPlan] = useState();
  const [showNewPlanModal, setShowNewPlanModal] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState();
  const [modalLoading, setModalLoading] = useState(false);
  const [missingPlan, setMissingPlan] = useState(null);
  const [, setParentPlanId] = useState(null);

  const [advisoryType, setAdvisoryType] = useState('Index Long Term Strategy');
  const [selectedPlanName, setSelectedPlanName] = useState(undefined);
  const [selectedRiskProfile, setSelectedRiskProfile] = useState(undefined);
  const [portfolioFiles, setPortfolioFiles] = useState([]);
  const [portfolioFileUploads, setPortfolioFileUploads] = useState([]);
  const [portfolioUploadLoading, setPortfolioUploadLoading] = useState(false);
  const [portfolioCalculationLoading, setPortfolioCalculationLoading] =
    useState(false);
  const [portfolioResult, setPortfolioResult] = useState([]);
  const [portfolioError, setPortfolioError] = useState("");
  const [portfolioValuationDate] = useState("");
  const [portfolioAmountToShift] = useState(
    initialInvestment || ""
  );

  const portfolioFileInputRef = React.useRef(null);
  const portfolioPollingIntervalRef = React.useRef(null);

  const { data: userAddonsData } = useQuery(GET_USER_ADDONS, {
    fetchPolicy: "network-only",
  });

  const parentUserId = userAddonsData?.getUserAddons?.parentId;

  useEffect(() => {
    if (parentUserId || currentUser?.completedSteps === 'DONE') {
      if (isPortfolioBetaProduct(currentUser)) {
        setAdvisoryType('FinRakshak - Portfolio Beta Hedging Advisory')
      } else if (isFinsaverProduct(currentUser)) {
        setAdvisoryType('FINSaver Advisory - Debt Advisory')
      } else {
        setAdvisoryType('Index Long Term Strategy')
      }
    }
  }, [currentUser, selectedPlanType, parentUserId])

  const { loading, error, data } = useQuery(GET_PLANS_BASED_POINTS, {
    variables: { points: clientScore },
    fetchPolicy: "network-only",
  });
  const { data: niftyData, loading: niftyLoading } = useQuery(GET_NIFTY, {
    fetchPolicy: "network-only",
  });

  const { data: parentUserData } = useQuery(GET_USER, {
    variables: { id: parentUserId },
    skip: !parentUserId,
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (parentUserData?.getUser?.plan?.id) {
      setParentPlanId(parentUserData.getUser.plan.id);
    }
  }, [parentUserData]);

  let { data: maxExposure, loading: exposureLoading } = useQuery(
    GET_MAX_EXPOSURE,
    {
      fetchPolicy: "network-only",
    }
  );

  const { data: panCardUsersData, loading: panCardUsersLoading } = useQuery(
    GET_USERS_BY_PAN_CARD,
    {
      variables: {
        where: {
          panCardNo: currentUser?.panCardNo,
          isActive: ['true']
        }
      },
      skip: !currentUser?.panCardNo,
      fetchPolicy: 'network-only',
    },
  )

  const rawCurrentUserPlanId =
    currentUser?.planId || currentUser?.plan?.id || null
  const isPortfolioBetaFlow =
    selectedPlanType !== 'new' &&
    (isPortfolioBetaProduct(currentUser) || advisoryType === 'FinRakshak - Portfolio Beta Hedging Advisory')

  const adjustedMaxExposure = React.useMemo(() => {
    if (!maxExposure?.getMaxExposure?.maxExposure) return null

    const parentLimit = parseFloat(maxExposure.getMaxExposure.maxExposure) || 0

    const adjusted = parentLimit
    return adjusted > 0 ? adjusted : 0
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maxExposure, panCardUsersData])

  const calculatedMaxExposure = React.useMemo(() => {
    if (
      !exposureLoading &&
      !panCardUsersLoading &&
      !niftyLoading &&
      !loading &&
      state?.currentUser?.isNewAuaAdvisoryGenerate
    ) {
      const auaMaxLimit = Math.max(0, parseInt(state?.currentUser?.auaMaxLimit) || 0)

      return auaMaxLimit
    }
    return null
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exposureLoading, panCardUsersLoading, niftyLoading, loading, state, panCardUsersData])

  const finalMaxExposure = calculatedMaxExposure !== null
    ? calculatedMaxExposure
    : adjustedMaxExposure

  const isLimitExceeded = React.useMemo(() => {
    const maxExposureValue = finalMaxExposure !== null
      ? finalMaxExposure
      : (maxExposure?.getMaxExposure?.maxExposure || 0);
    if (!maxExposureValue || !exposureValue) return false;
    return exposureValue > maxExposureValue;
  }, [exposureValue, finalMaxExposure, maxExposure]);

  const renderLimitWarningCard = () => {
    if (!isLimitExceeded) return null;

    const allowedLimit = finalMaxExposure !== null
      ? finalMaxExposure
      : (maxExposure?.getMaxExposure?.maxExposure || 0);
    const requestedExposure = exposureValue;

    if (isNewAuaAdvisoryGenerate) {
      // Add AUA client flow
      return (
        <div style={{
          border: '1px solid #ffa39e',
          backgroundColor: '#fff1f0',
          borderRadius: '8px',
          padding: '16px',
          marginTop: '20px',
          marginBottom: '20px',
          boxShadow: '0 4px 12px rgba(255, 77, 79, 0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <span role="img" aria-label="warning" style={{ fontSize: '18px', marginRight: '8px' }}>⚠️</span>
            <span style={{ fontWeight: 'bold', color: '#cf1322', fontSize: '16px' }}>Limit Exceeded</span>
          </div>
          <div style={{ color: '#434343', fontSize: '14px', lineHeight: '1.6' }}>
            You are initiating investment exposure in access of your net worth as per the risk profile with Finideas. You are requested to either reduce the investment exposure or can review the risk profile with us.
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px', padding: '8px 0', borderTop: '1px solid #f5222d22', borderBottom: '1px solid #f5222d22', fontSize: '13px' }}>
            <div><strong>Requested Exposure:</strong> ₹{convertNumberToCommaSeparate(requestedExposure, false)}</div>
            <div><strong>Allowed Limit:</strong> ₹{convertNumberToCommaSeparate(allowedLimit, false)}</div>
          </div>
          <div style={{ marginTop: '16px', textAlign: 'right' }}>
            <Button
              type="primary"
              danger
              onClick={() => {
                window.location.href = '/reevalute';
              }}
              style={{ borderRadius: '6px', fontWeight: '500' }}
            >
              Re-Evaluate
            </Button>
          </div>
        </div>
      );
    } else {
      // Onboarding flow
      return (
        <div style={{
          border: '1px solid #ffa39e',
          backgroundColor: '#fff1f0',
          borderRadius: '8px',
          padding: '16px',
          marginTop: '20px',
          marginBottom: '20px',
          boxShadow: '0 4px 12px rgba(255, 77, 79, 0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
            <span role="img" aria-label="warning" style={{ fontSize: '18px', marginRight: '8px' }}>⚠️</span>
            <span style={{ fontWeight: 'bold', color: '#cf1322', fontSize: '16px' }}>Limit Exceeded</span>
          </div>
          <div style={{ color: '#434343', fontSize: '14px', lineHeight: '1.6' }}>
            You are initiating investment exposure in access of your net worth as per the risk profile with Finideas. You are requested to either reduce the investment exposure or can review the risk profile with us.
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px', padding: '8px 0', borderTop: '1px solid #f5222d22', borderBottom: '1px solid #f5222d22', fontSize: '13px' }}>
            <div><strong>Requested Exposure:</strong> ₹{convertNumberToCommaSeparate(requestedExposure, false)}</div>
            <div><strong>Allowed Limit:</strong> ₹{convertNumberToCommaSeparate(allowedLimit, false)}</div>
          </div>
          <div style={{ marginTop: '16px', textAlign: 'right' }}>
            <Button
              type="primary"
              danger
              onClick={() => {
                const targetStep = currentUser?.isPanCardIndividual
                  ? (currentUser?.cvlStatus === true ? 'CLIENT_PROFILE_2' : 'KYC_DOC')
                  : 'CLIENT_PROFILE_2';

                if (typeof newEdit === 'function') {
                  newEdit({ completedSteps: targetStep });
                } else if (typeof back === 'function') {
                  back(2);
                }
              }}
              style={{ borderRadius: '6px', fontWeight: '500' }}
            >
              Re-Assessment
            </Button>
          </div>
        </div>
      );
    }
  };

  useEffect(() => {
    const tempAnnualIncome = annualIncome || 0;
    let minimumExposure =
      50000 *
      Math.floor((niftyData?.getNifty50[0]?.CMP * niftyLotSize) / 50000);

    if (advisoryType === 'FINSaver Advisory - Debt Advisory' || isFinsaverProduct(currentUser)) {
      minimumExposure = 100000;
    }

    // Use final max exposure (calculated for new AUA or adjusted for regular case)
    const maxExposureValue = finalMaxExposure !== null
      ? finalMaxExposure
      : (maxExposure?.getMaxExposure?.maxExposure || 0)

    if (maxExposureValue < minimumExposure) {
      setErrorMessage(
        `Your remaining exposure (${convertNumberToCommaSeparate(
          +maxExposureValue
        )}) is lower than the minimum required exposure (${convertNumberToCommaSeparate(
          +minimumExposure
        )}).`
      );
    } else if (exposureValue && tempAnnualIncome) {
      if (maxExposureValue < exposureValue) {
        if (isNewAuaAdvisoryGenerate) {
          setErrorMessage(
            "You are initiating investment exposure in access of your net worth as per the risk profile with Finideas. You are requested to either reduce the investment exposure or can review the risk profile with us."
          );
        } else {
          setErrorMessage(
            "You are initiating investment exposure in access of your net worth as per the risk profile with Finideas. You are requested to either reduce the investment exposure or can review the risk profile with us."
          );
        }
      } else if (minimumExposure > exposureValue) {
        setErrorMessage(
          `Exposure value can't be less than ${convertNumberToCommaSeparate(
            +minimumExposure
          )}`
        );
      } else {
        setErrorMessage("");
      }
    } else {
      setErrorMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exposureValue, finalMaxExposure, maxExposure, isNewAuaAdvisoryGenerate, advisoryType, currentUser, selectedPlanType])

  let allPlans =
    !loading &&
      !niftyLoading &&
      !exposureLoading &&
      get(data, "fetchPlansBasedOnPoints")
      ? get(data, "fetchPlansBasedOnPoints")
      : [];

  const portfolioBetaPlan = React.useMemo(
    () =>
      allPlans.find(
        (plan) =>
          String(plan?.strategyCode || "") ===
          String(PORTFOLIO_BETA_STRATEGY_CODE) ||
          (plan?.name || "").toLowerCase().includes("finrakshak")
      ) || null,
    [allPlans]
  );

  const currentUserPlanId =
    rawCurrentUserPlanId ||
    (isPortfolioBetaFlow ? portfolioBetaPlan?.id || null : null)

  const portfolioBetaLabel = portfolioBetaPlan?.name
    ? `${portfolioBetaPlan.name} - Portfolio Beta Hedging Advisory`
    : PORTFOLIO_BETA_DISPLAY_LABEL

  const panCardPlanIds = React.useMemo(() => {
    if (!panCardUsersData?.getUsers?.users?.length) return [];
    return Array.from(
      new Set(
        panCardUsersData.getUsers.users
          .map((user) => user?.plan?.id)
          .filter((id) => id !== undefined && id !== null)
      )
    );
  }, [panCardUsersData]);

  const activePlanName = (currentUser?.plan?.name || '').trim().toLowerCase();
  const activePlanId = currentUser?.plan?.id;

  const newPlanOptions = React.useMemo(() => {
    return (allPlans || []).filter((plan) => {
      if (
        String(plan.id) === String(currentUserPlanId) ||
        String(plan.id) === String(activePlanId)
      )
        return false;
      return !panCardPlanIds.some(
        (panPlanId) => String(panPlanId) === String(plan.id)
      );
    });
  }, [allPlans, currentUserPlanId, activePlanId, panCardPlanIds]);

  const availableIltsPlans = React.useMemo(() => {
    return (newPlanOptions || []).filter((p) => {
      const n = (p?.name || '').trim().toLowerCase();
      return (
        n.includes('basic') ||
        n.includes('relax') ||
        n.includes('power booster') ||
        n.includes('comfort') ||
        n.includes('marathon') ||
        n.includes('index long term strategy')
      );
    });
  }, [newPlanOptions]);

  const availableFinRakshakPlan = React.useMemo(() => {
    if (isPortfolioBetaProduct(currentUser)) return null;
    return (
      (newPlanOptions || []).find((p) => {
        const n = (p?.name || '').toLowerCase();
        return (
          String(p?.strategyCode || '') === String(PORTFOLIO_BETA_STRATEGY_CODE) ||
          n.includes('rakshak') ||
          n.includes('beta')
        );
      }) || null
    );
  }, [newPlanOptions, currentUser]);

  const userClientScore = currentUser?.clientScore;
  const getRiskProfileOptions = React.useCallback(() => {
    const score = userClientScore || clientScore || 0;
    if (score <= 41) return ['Conservative'];
    if (score >= 42 && score <= 65) return ['Moderate', 'Conservative'];
    return ['Conservative', 'Moderate', 'Aggressive'];
  }, [userClientScore, clientScore]);

  const availableFinSaverPlans = React.useMemo(() => {
    const allowedProfiles = getRiskProfileOptions().map((opt) => opt.toLowerCase());
    return (newPlanOptions || []).filter((p) => {
      const n = (p?.name || '').trim().toLowerCase();
      const isFinSaverName =
        n.includes('finsaver') ||
        n.includes('conservative') ||
        n.includes('moderate') ||
        n.includes('aggressive');
      const isRiskScoreAllowed = allowedProfiles.some(
        (opt) => n.includes(opt) || opt.includes(n)
      );
      return isFinSaverName && isRiskScoreAllowed;
    });
  }, [newPlanOptions, getRiskProfileOptions]);

  const availableAdvisoryTypes = React.useMemo(() => {
    const types = [];

    // Check Index Long Term Strategy
    const hasIndexPlans = (newPlanOptions || []).some((p) => {
      const n = (p?.name || '').trim().toLowerCase();
      const isMatchesActive = activePlanName && n === activePlanName;
      return (
        (n.includes('basic') ||
          n.includes('relax') ||
          n.includes('power booster') ||
          n.includes('comfort') ||
          n.includes('marathon') ||
          n.includes('index long term strategy')) &&
        !isMatchesActive
      );
    });
    if (hasIndexPlans) {
      types.push('Index Long Term Strategy');
    }

    // Check FinRakshak - Portfolio Beta Hedging Advisory
    const hasFinRakshakPlans = (newPlanOptions || []).some((p) => {
      const n = (p?.name || '').trim().toLowerCase();
      const isMatchesActive =
        activePlanName &&
        (n === activePlanName || activePlanName.includes(n) || n.includes(activePlanName));
      return (
        (n.includes('finrakshak') ||
          n.includes('rakshak') ||
          n.includes('beta')) &&
        !isMatchesActive
      );
    });
    if (hasFinRakshakPlans) {
      types.push('FinRakshak - Portfolio Beta Hedging Advisory');
    }

    // Check FINSaver Advisory - Debt Advisory
    const allowedProfiles = getRiskProfileOptions().map((opt) =>
      opt.toLowerCase()
    );
    const hasFinSaverPlans = (newPlanOptions || []).some((p) => {
      const n = (p?.name || '').trim().toLowerCase();
      const isMatchesActive =
        activePlanName &&
        (n === activePlanName || activePlanName.includes(n) || n.includes(activePlanName));
      const isRiskScoreAllowed = allowedProfiles.some(
        (opt) => n.includes(opt) || opt.includes(n)
      );
      return (
        (n.includes('conservative') ||
          n.includes('moderate') ||
          n.includes('aggressive') ||
          n.includes('finsaver')) &&
        isRiskScoreAllowed &&
        !isMatchesActive
      );
    });
    if (hasFinSaverPlans) {
      types.push('FINSaver Advisory - Debt Advisory');
    }

    return types;
  }, [newPlanOptions, activePlanName, getRiskProfileOptions]);

  useEffect(() => {
    if (selectedPlanType === 'new' && availableAdvisoryTypes.length > 0) {
      if (!availableAdvisoryTypes.includes(advisoryType)) {
        setAdvisoryType(availableAdvisoryTypes[0]);
        setSelectedPlanName(undefined);
        setSelectedRiskProfile(undefined);
        setSelectedNewPlan(undefined);
      }
    }
  }, [availableAdvisoryTypes, advisoryType, selectedPlanType]);

  useEffect(() => {
    if (!form) return;
    if (!currentUserPlanId) return;

    form.setFieldsValue({
      plan: parseInt(currentUserPlanId),
    });
  }, [currentUserPlanId, form]);

  useEffect(() => {
    if (!form || isPortfolioBetaFlow) return;

    const selectedPlan = form.getFieldValue('plan');
    if (
      selectedPlan &&
      portfolioBetaPlan?.id &&
      String(selectedPlan) === String(portfolioBetaPlan.id)
    ) {
      form.setFieldsValue({ plan: undefined });
      setReviewPlanData(undefined);
    }
  }, [form, isPortfolioBetaFlow, portfolioBetaPlan]);

  useEffect(() => {
    if (selectedPlanType === 'new') {
      if (advisoryType === 'FinRakshak - Portfolio Beta Hedging Advisory') {
        if (availableFinRakshakPlan?.id) {
          setSelectedNewPlan(availableFinRakshakPlan.id);
        } else {
          setSelectedNewPlan(undefined);
        }
      } else if (advisoryType === 'FINSaver Advisory - Debt Advisory' && selectedRiskProfile) {
        const found = availableFinSaverPlans.find((p) =>
          (p?.name || '').toLowerCase().includes(selectedRiskProfile.toLowerCase())
        );
        setSelectedNewPlan(found?.id);
      } else if (advisoryType === 'Index Long Term Strategy' && selectedPlanName) {
        const found = availableIltsPlans.find(
          (p) => (p?.name || '').trim().toLowerCase() === selectedPlanName.trim().toLowerCase()
        );
        setSelectedNewPlan(found?.id);
      }
    }
  }, [
    selectedPlanType,
    advisoryType,
    selectedRiskProfile,
    selectedPlanName,
    availableIltsPlans,
    availableFinRakshakPlan,
    availableFinSaverPlans,
  ]);

  const getPlanDescription = () => {
    if (advisoryType === 'FinRakshak - Portfolio Beta Hedging Advisory') {
      return 'FinRakshak helps protect your existing stock and mutual fund investments from major market declines. It analyzes your portfolio, creates a customized protection strategy, and continuously monitors market conditions so you can stay invested with greater confidence and peace of mind.'
    }
    if (advisoryType === 'FINSaver Advisory - Debt Advisory') {
      if (selectedRiskProfile === 'Conservative') return 'Prefers safety over high returns. Comfortable with steady growth and wants to avoid large losses in their investments.'
      if (selectedRiskProfile === 'Moderate') return 'Looks for a balance between safety and growth. Can handle some ups and downs in the market to earn better returns over time.'
      if (selectedRiskProfile === 'Aggressive') return 'Aims for higher returns and is comfortable with market fluctuations. Understands that investments may rise and fall significantly in the short term for potentially higher long-term gains.'
      return 'FinSaver is a fixed-income investment solution for investors seeking stable and regular returns. Based on your risk profile, it invests in a diversified mix of bonds and debt instruments to provide consistent income, capital stability, and lower volatility.'
    }
    if (advisoryType === 'Index Long Term Strategy') {
      if (selectedPlanName === 'Relax Plan') return 'A low-risk investment plan designed for investors who prefer stability and peace of mind. It provides market-linked growth with built-in protection against major market falls, helping you grow your wealth steadily while keeping risk under control.'
      if (selectedPlanName === 'Marathon Plan') return 'A growth-focused investment plan for investors looking for higher long-term returns. It increases market participation while maintaining downside protection, allowing you to benefit from market growth with controlled risk.'
      return 'ILTS is a long-term investment strategy that combines index investing, smart use of leverage, portfolio protection, and debt investments. It aims to grow wealth over time while reducing the impact of market downturns and providing a smoother investment journey.'
    }
    return ''
  }

  const isSelectionComplete = () => {
    if (parentUserId || currentUser?.completedSteps === 'DONE') return true
    if (advisoryType === 'Index Long Term Strategy') return !!selectedPlanName
    if (advisoryType === 'FinRakshak - Portfolio Beta Hedging Advisory') return true
    if (advisoryType === 'FINSaver Advisory - Debt Advisory') return !!selectedRiskProfile
    return false
  }

  useEffect(() => {
    if ((parentUserId || currentUser?.completedSteps === 'DONE') && selectedPlanType !== 'new') {
      if (currentUserPlanId) {
        form.setFieldsValue({ plan: parseInt(currentUserPlanId) });
      }
      return;
    }

    let selectedPlanObj = null
    if (advisoryType === 'Index Long Term Strategy' && selectedPlanName) {
      selectedPlanObj = allPlans.find(p => p.name.trim().toLowerCase() === selectedPlanName.trim().toLowerCase() || p.name.trim().toLowerCase().includes(selectedPlanName.trim().toLowerCase()))
    } else if (advisoryType === 'FinRakshak - Portfolio Beta Hedging Advisory') {
      selectedPlanObj = allPlans.find(p => p.name.trim().toLowerCase().includes('finrakshak') || p.name.trim().toLowerCase().includes('rakshak') || p.name.trim().toLowerCase().includes('beta')) || allPlans[0]
    } else if (advisoryType === 'FINSaver Advisory - Debt Advisory' && selectedRiskProfile) {
      selectedPlanObj = allPlans.find(p => p.name.trim().toLowerCase() === selectedRiskProfile.trim().toLowerCase())
      if (!selectedPlanObj) {
        selectedPlanObj = allPlans.find(p => p.name.trim().toLowerCase().includes(selectedRiskProfile.trim().toLowerCase()))
      }
    }

    if (selectedPlanObj?.id) {
      form.setFieldsValue({ plan: parseInt(selectedPlanObj.id) })
      setSelectedNewPlan(selectedPlanObj.id)
    } else {
      if (selectedPlanType !== 'new') {
        form.setFieldsValue({ plan: undefined })
        setSelectedNewPlan(null)
      }
    }
    setReviewPlanData()
  }, [advisoryType, selectedPlanName, selectedRiskProfile, allPlans, form, parentUserId, currentUser, currentUserPlanId, selectedPlanType])

  useEffect(() => {
    if (!form || isPortfolioBetaFlow) return;

    const selectedPlan = form.getFieldValue("plan");
    if (
      selectedPlan &&
      portfolioBetaPlan?.id &&
      String(selectedPlan) === String(portfolioBetaPlan.id)
    ) {
      form.setFieldsValue({ plan: undefined });
      setReviewPlanData(undefined);
    }
  }, [form, isPortfolioBetaFlow, portfolioBetaPlan]);


  useEffect(() => {
    const parentPlanId = currentUserPlanId;
    if (!parentPlanId) return;
    const exists = allPlans.find((p) => String(p?.id) === String(parentPlanId));
    if (!exists) {
      client
        .query({
          query: GET_PLAN,
          variables: { where: { id: parentPlanId } },
          fetchPolicy: "network-only",
        })
        .then((res) => {
          const plan = res?.data?.getPlan;
          if (plan) setMissingPlan(plan);
        })
        .catch(() => { });
    } else {
      setMissingPlan(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allPlans, currentUserPlanId]);

  const portfolioSummary = React.useMemo(
    () => getPortfolioSummary(portfolioResult),
    [portfolioResult]
  );

  const portfolioHoldingRows = React.useMemo(
    () => getPortfolioHoldingRows(portfolioResult),
    [portfolioResult]
  );

  const portfolioColumns = React.useMemo(() => {
    if (!portfolioHoldingRows.length) return [];

    return Object.keys(portfolioHoldingRows[0])
      .filter((key) => {
        const normalizedKey = normalizePortfolioKey(key);
        return (
          !normalizedKey.includes("portfoliobeta") &&
          !normalizedKey.includes("totalvalue") &&
          !normalizedKey.includes("hedgingcost")
        );
      })
      .map((key) => ({
        title: formatPortfolioColumnTitle(key),
        dataIndex: key,
        key,
        render: (value) => formatPortfolioCell(value, key),
      }));
  }, [portfolioHoldingRows]);

  const onFinish = (values) => {
    values = {
      ...values,
      exposure: exposureValue,
    };
    setLoader(true);
    dispatch({ type: "IS_RESUBMIT_LOADING", data: true });
    client
      .query({
        query: GET_SP_AUTO_ADVISE,
        variables: {
          where: {
            dontBuyEquity: "NO",
            exposure: parseInt(values.exposure),
            planId: parseInt(values.plan),
            udInvestment: values.udInvestment,
            source:
              currentUser?.role !== "CLIENT"
                ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                : window?.location?.pathname === "/add-aua-verification"
                  ? "ADD AUA"
                  : window?.location?.pathname === "/pending-advisory"
                    ? "Pending Advisory"
                    : "Onboarding",
          },
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        entityStatus &&
          client.query({
            query: GENERATE_NON_INDIVIDUAL_REPORT,
            variables: {
              where: {
                dontBuyEquity: "YES",
                entityStatus: entityStatus,
              },
            },
            fetchPolicy: "network-only",
          });
        setReviewPlanData(res?.data?.spAutoAdvise);
        dispatch({ type: "SHOW_REVIEW_PLAN", data: true });
        dispatch({ type: "IS_RESUBMIT_LOADING", data: false });
      })

      .finally(() => {
        setLoader(false);
        dispatch({ type: "IS_RESUBMIT_LOADING", data: false });
      });
  };

  const Columns = [
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      className: "report-text",
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "Value",
      className: "report-numeric review_plan",
      render: (record) =>
        record?.includes("Plan")
          ? record
          : convertNumberToCommaSeparate(+record, false),
    },
  ];

  const newColumns = [
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      className: "report-text",
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "Value",
      className: "report-numeric review_plan",
      render: (record) => convertNumberToCommaSeparate(+record, false),
    },
    {
      title: "Annualised %",
      dataIndex: "Per",
      key: "Per",
      className: "report-numeric review_plan",
      render: (text) => parseFloat(text).toFixed(2),
    },
  ];

  const finRakshakColumns = [
    {
      title: "Descriptions",
      dataIndex: "Description",
      key: "Description",
      className: "report-text",
    },
    {
      title: "Value",
      dataIndex: "Value",
      key: "Value",
      className: "report-numeric review_plan",
      render: (record) => {
        if (record === null || record === undefined || record === "") return "";
        if (typeof record === "string" && isNaN(Number(record))) {
          return record;
        }
        const num = Number(record);
        if (isNaN(num)) return record;
        return convertNumberToCommaSeparate(num, false);
      },
    },
    {
      title: "Annualised %",
      dataIndex: "Per",
      key: "Per",
      className: "report-numeric review_plan",
      render: (text) =>
        text !== undefined && text !== null && text !== "" && !isNaN(Number(text))
          ? parseFloat(text).toFixed(2)
          : "-",
    },
  ];

  const normalizedReviewPlanData = React.useMemo(() => {
    if (!reviewPlanData?.length) return [];

    return reviewPlanData.map((row) => {
      if (row.Description === "Stocks/MF.") {
        return {
          ...row,
          Description: "Collateral",
        };
      }

      if (row.Description === "SIP (Per Month)") {
        return {
          ...row,
          Value: parseInt(row?.Value, 10).toFixed(0),
        };
      }

      return row;
    });
  }, [reviewPlanData]);

  const isFinRakshak = React.useMemo(() => {
    const hasRakshakInReviewData = (reviewPlanData || []).some(
      (row) =>
        (row.Description === "Product recommended" ||
          row.Description === "Your selected plan is ") &&
        String(row.Value || "").toLowerCase().includes("rakshak")
    );
    if (hasRakshakInReviewData) return true;

    const selectedPlanId = form?.getFieldValue?.("plan");
    if (selectedPlanId) {
      const selectedPlanObj = (allPlans || []).find(
        (p) => String(p.id) === String(selectedPlanId)
      );
      if (
        selectedPlanObj &&
        (String(selectedPlanObj?.strategyCode) === String(PORTFOLIO_BETA_STRATEGY_CODE) ||
          (selectedPlanObj?.name || "").toLowerCase().includes("rakshak"))
      ) {
        return true;
      }
    }

    return isPortfolioBetaFlow;
  }, [allPlans, form, isPortfolioBetaFlow, reviewPlanData]);

  const finRakshakRows = React.useMemo(() => {
    if (!isFinRakshak) return [];
    if (!normalizedReviewPlanData?.length && !portfolioResult?.length) return [];

    const betaSummaryObj =
      (portfolioResult || []).find(
        (row) =>
          row?.HedgeCost !== undefined ||
          row?.HedgeCostper !== undefined ||
          row?.HedgingCost !== undefined ||
          row?.A_Aper !== undefined ||
          row?.FinalExposure !== undefined ||
          row?.AMCValue !== undefined
      ) || portfolioResult?.[0];

    const result = [];

    // 1. Product recommended (single row)
    const productRow = (normalizedReviewPlanData || []).find(
      (row) =>
        row.Description === "Product recommended" ||
        row.Description === "Your selected plan is "
    );
    result.push({
      Description: "Product recommended",
      Value: productRow?.Value || portfolioBetaPlan?.name || "FinRakshak",
      Per: undefined,
    });

    // 2. Exposure row
    const exposureRow =
      (normalizedReviewPlanData || []).find(
        (row) => row.Description === "Exposure" && row.Value
      ) || (normalizedReviewPlanData || []).find((row) => row.Description === "Exposure");
    const expValue = betaSummaryObj?.FinalExposure ?? exposureRow?.Value;
    if (expValue !== undefined || exposureRow) {
      result.push({
        Description: "Exposure",
        Value: expValue !== undefined ? expValue : exposureRow?.Value,
        Per: exposureRow?.Per,
      });
    }

    // 3. Hedging Cost row (for FinRakshak, display "Hedging Cost:" and map HedgeCost & HedgeCostper)
    const hedgingRow = (normalizedReviewPlanData || []).find(
      (row) =>
        (row.Description === "Hedging Cost" ||
          row.Description === "Hedging Cost:" ||
          row.Description === "Hedging & Financing Cost") &&
        (row.Value || row.Per)
    );

    const spHedgeCost = betaSummaryObj?.HedgeCost ?? betaSummaryObj?.HedgingCost;
    const spHedgeCostPer = betaSummaryObj?.HedgeCostper ?? betaSummaryObj?.A_Aper;

    const hedgeValue = spHedgeCost !== undefined ? spHedgeCost : hedgingRow?.Value;
    const hedgePer = spHedgeCostPer !== undefined ? spHedgeCostPer : hedgingRow?.Per;

    if (hedgeValue !== undefined || hedgePer !== undefined || hedgingRow) {
      result.push({
        Description: "Hedging Cost",
        Value: hedgeValue,
        Per: hedgePer,
      });
    }

    // 4. AMC (including GST) row
    const amcRow = (normalizedReviewPlanData || []).find(
      (row) => row.Description === "AMC (including GST)"
    );
    const spAmcVal = betaSummaryObj?.AMCValue;
    const spAmcPer = betaSummaryObj?.AMCPer;
    const amcValue = spAmcVal !== undefined ? spAmcVal : amcRow?.Value;
    const amcPer = spAmcPer !== undefined ? spAmcPer : amcRow?.Per;

    if (amcValue !== undefined || amcPer !== undefined || amcRow) {
      result.push({
        Description: "AMC (including GST)",
        Value: amcValue !== undefined ? amcValue : amcRow?.Value,
        Per: amcPer !== undefined ? amcPer : amcRow?.Per,
      });
    }

    return result;
  }, [isFinRakshak, normalizedReviewPlanData, portfolioBetaPlan, portfolioResult]);

  const reviewPlanSummaryRows = React.useMemo(
    () =>
      normalizedReviewPlanData
        .filter((row) => row.Description !== "-------: Features :-------")
        .slice(0, 6),
    [normalizedReviewPlanData]
  );

  const isFinsaver = React.useMemo(() => {
    return (
      advisoryType === 'FINSaver Advisory - Debt Advisory' ||
      isFinsaverProduct(currentUser) ||
      (normalizedReviewPlanData &&
        normalizedReviewPlanData.some(
          (row) =>
            row.Value === 'FINSAVER' ||
            row.Description === 'FINSAVER' ||
            (row.Description === 'Product recommended' && row.Value?.toUpperCase() === 'FINSAVER')
        ))
    );
  }, [advisoryType, currentUser, normalizedReviewPlanData]);

  const reviewPlanAnnualisedRows = React.useMemo(
    () => {
      const filtered = normalizedReviewPlanData.filter(
        (row) => row.Per && row.Description !== "Net Payment"
      )
      if (isFinsaver) {
        return filtered.filter(
          (row) => row.Description === "AMC (including GST)" || row.Description?.includes("AMC")
        )
      }
      return filtered
    },
    [normalizedReviewPlanData, isFinsaver]
  );

  useEffect(() => {
    return () => {
      if (portfolioPollingIntervalRef.current) {
        clearInterval(portfolioPollingIntervalRef.current);
      }
    };
  }, []);

  if (error) return <Page404 error={error} />

  const planMail = () => {
    setPlanLoader(true);
    dispatch({ type: "IS_ACCEPT_LOADING", data: true });
    form.validateFields().then((values) => {
      values = {
        ...values,
        exposure: exposureValue,
      }

      // Get mandate amount from review plan data
      const amcData = reviewPlanData?.find((a) => a.Description === 'AMC (including GST)')
      const newMandateAmount = amcData?.mandateAmount
        ? parseFloat(amcData.mandateAmount)
        : amcData?.Value
          ? parseFloat(amcData.Value)
          : null
      const grossAmcData = reviewPlanData?.find((a) =>
        Object.keys(a).includes('GrossAMC'),
      )
      const totalNetAmount =
        (Number(grossAmcData?.GrossAMC) || 0) +
        (Number(grossAmcData?.GST) || 0)
      const registeredLimit = currentUser?.compareMandateAmount ? parseFloat(currentUser.compareMandateAmount) : 0
      console.log('E_MANDATE_SP_VALUES', {
        userId: currentUser?.id,
        grossAmc: Number(grossAmcData?.GrossAMC) || 0,
        gst: Number(grossAmcData?.GST) || 0,
        totalNetAmount,
        compareMandateAmount: registeredLimit,
      })

      const effectivePlanId =
        values?.plan || selectedNewPlan || currentUserPlanId || currentUser?.planId;

      const matchedPlan =
        (allPlans || []).find(
          (item) => String(item?.id) === String(effectivePlanId)
        ) ||
        currentUser?.plan ||
        missingPlan ||
        portfolioBetaPlan;

      const finalPlanName = matchedPlan?.name || "";

      client
        .mutate({
          initialInvestment: values.udInvestment,
          mutation: INVESTMENT_PLANNING_MAIL,
          variables: {
            where: {
              planId: parseInt(effectivePlanId),
              dontBuyEquity: "YES",
              exposure: parseInt(values.exposure),
              udInvestment: parseInt(values.udInvestment),
              source:
                currentUser?.role !== "CLIENT"
                  ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                  : window?.location?.pathname === "/add-aua-verification"
                    ? "ADD AUA"
                    : window?.location?.pathname === "/pending-advisory"
                      ? "Pending Advisory"
                      : "Onboarding",
            },
          },
        })
        .then((res) => {
          client
            .query({
              query: GET_SP_AGREEMENT_DATA,
              variables: {
                where: {
                  dontBuyEquity: "YES",
                  source:
                    currentUser?.role !== "CLIENT"
                      ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                      : window?.location?.pathname === "/add-aua-verification"
                        ? "ADD AUA"
                        : window?.location?.pathname === "/pending-advisory"
                          ? "Pending Advisory"
                          : "Onboarding",
                },
              },
            })
            .then(async () => {
              if (!isPanCardIndividual) {
                await client.query({
                  query: GENERATE_NON_INDIVIDUAL_REPORT,
                  variables: {
                    where: {
                      dontBuyEquity: "YES",
                      entityStatus: entityStatus,
                    },
                  },
                  fetchPolicy: "network-only",
                });

                const kycResponse = await client.query({
                  query: GET_KYC,
                  variables: { userId: parseInt(id, 10) },
                  fetchPolicy: "network-only",
                });

                const agreementForNonIndividual =
                  kycResponse?.data?.kyc?.agreementForNonIndividual;

                if (!agreementForNonIndividual) {
                  setPlanLoader(false);
                  dispatch({ type: "IS_ACCEPT_LOADING", data: false });
                  openNotification(
                    "error",
                    "Agreement PDF was not generated. Please try again."
                  );
                  return;
                }

                const mailResponse = await client.query({
                  query: NON_INDIVIDUAL_AGREEMENT_MAIL_SEND,
                  fetchPolicy: "network-only",
                });

                if (!mailResponse?.data?.nonIndividualAgreementMailSend) {
                  openNotification(
                    "warning",
                    "Agreement PDF is ready, but email could not be sent."
                  );
                }
              }
              let updateUserData = {
                planId: parseInt(effectivePlanId),
                initialInvestment: values.udInvestment,
                mandateAmount: totalNetAmount > 0 ? totalNetAmount : (newMandateAmount || 0),
              };
              if (isNewAuaAdvisoryGenerate || completedSteps === "DONE") {
                updateUserData.newAuaAdvisoryCompletedSteps =
                  "INVESTMENT_PLANNING";
                updateUserData.isNewAuaAdvisoryGenerate = true;
              } else {
                // Use final max exposure (calculated for new AUA or adjusted for regular case)
                const maxExposureValue = finalMaxExposure !== null
                  ? finalMaxExposure
                  : (maxExposure?.getMaxExposure?.maxExposure || 0)
                updateUserData.annualIncome = maxExposureValue.toString()
                updateUserData.completedSteps = 'INVESTMENT_PLANNING'
              }

              client
                .mutate({
                  mutation: UPDATE_USER,
                  variables: {
                    id: id,
                    data: { ...updateUserData },
                  },
                })
                .then((res) => {
                  if (
                    !isNewAuaAdvisoryGenerate &&
                    currentUser?.completedSteps !== "DONE"
                  ) {
                    const currentIndex = clientSummaryDetails?.findIndex(
                      (item) => item?.name === "Investment Planning"
                    );
                    const updateClientSummaryDetails = {
                      name: "Investment Planning",
                      isDisplayEdit: true,
                      completedSteps: "SUMMARY",
                      data: {
                        "Your Selected Exposure":
                          formatToLakhsOrCrores(exposureValue),
                        "Your Advisory Plan": finalPlanName,
                      },
                    };
                    if (currentIndex !== -1) {
                      clientSummaryDetails[currentIndex] =
                        updateClientSummaryDetails;
                    } else {
                      clientSummaryDetails.push(updateClientSummaryDetails);
                    }

                    client.mutate({
                      mutation: COMPLETE_STEP,
                      variables: {
                        data: {
                          step: "INVESTMENT_PLANNING",
                          from: "WEB",
                        },
                      },
                    });
                  }
                  setPlanLoader(false);
                  dispatch({ type: "IS_ACCEPT_LOADING", data: false });
                  if (!isPanCardIndividual) {
                    dispatch({ type: "SHOW_REVIEW_PLAN", data: false });
                  }
                  dispatch({
                    type: "CURRENT_USER",
                    data: {
                      ...res.data.updateUser,
                      investmentAmount: values.udInvestment,
                      exposure: parseInt(values.exposure),
                    },
                  });
                  dispatch({
                    type: "CLIENT_SUMMARY_DETAILS",
                    data: clientSummaryDetails,
                  });
                  openNotification(
                    "success",
                    "Investment Planning Updated Successfully and Mail Sent"
                  );

                  // Check UserAddons.parentId to identify clone/copy users.
                  client
                    .query({
                      query: GET_USER_ADDONS,
                      fetchPolicy: "network-only",
                    })
                    .then((addonsRes) => {
                      const userAddons = addonsRes?.data?.getUserAddons

                      // If userAddons is null/undefined, proceed normally
                      if (!userAddons) {
                        next(1, res.data.updateUser)
                        return
                      }

                      const isClonedUser = Boolean(userAddons?.parentId)

                      // Clone/copy users should skip Agreement page flow.
                      if (isClonedUser) {
                        client
                          .mutate({
                            mutation: UPDATE_USER,
                            variables: {
                              id: id,
                              data: { ...(completedSteps === 'DONE' ? { newAuaAdvisoryCompletedSteps: 'INVESTMENT_PLANNING' } : { completedSteps: 'AGREEMENT_SIGN' }) },
                            },
                          })
                          .then(async (agreementRes) => {
                            dispatch({
                              type: "CURRENT_USER",
                              data: agreementRes.data.updateUser,
                            });
                            await client
                              .mutate({
                                mutation: COMPLETE_STEP,
                                variables: {
                                  data: {
                                    step: "AGREEMENT_SIGN",
                                    from: "WEB",
                                  },
                                },
                              })
                              .then(() => {
                                // Check mandate amount: if registered limit is less than new mandate fee, show E_MANDATE
                                // If registered limit is enough, skip E_MANDATE
                                if (totalNetAmount > 0 && registeredLimit < totalNetAmount) {
                                  console.log('E_MANDATE_DECISION_INVESTMENT_PLANNING', {
                                    userId: currentUser?.id,
                                    decision: 'SHOW_E_MANDATE',
                                    totalNetAmount,
                                    compareMandateAmount: registeredLimit,
                                  })
                                  // New mandate amount is larger, proceed to E_MANDATE step
                                  client
                                    .mutate({
                                      mutation: UPDATE_USER,
                                      variables: {
                                        id: id,
                                        data: {

                                          ...(completedSteps === 'DONE' ? { newAuaAdvisoryCompletedSteps: 'INVESTMENT_PLANNING' } : { completedSteps: 'AGREEMENT_SIGN' }),
                                          ...(isNewAuaAdvisoryGenerate && { newAuaAdvisoryCompletedSteps: 'INVESTMENT_PLANNING' })
                                        },
                                      },
                                    })
                                    .then((eMandateRes) => {
                                      dispatch({
                                        type: 'CURRENT_USER',
                                        data: eMandateRes.data.updateUser,
                                      })
                                      // Add AUA must open Advisory Fees (E-Mandate) when mandate limit is insufficient.
                                      next(
                                        isNewAuaAdvisoryGenerate ? 1 : 2,
                                        eMandateRes.data.updateUser
                                      )
                                    })
                                    .catch((eMandateErr) => {
                                      console.error('Error updating to E_MANDATE:', eMandateErr)
                                      next(
                                        isNewAuaAdvisoryGenerate ? 1 : 2,
                                        res.data.updateUser
                                      )
                                    })
                                } else {
                                  console.log('E_MANDATE_DECISION_INVESTMENT_PLANNING', {
                                    userId: currentUser?.id,
                                    decision: 'SKIP_E_MANDATE',
                                    totalNetAmount,
                                    compareMandateAmount: registeredLimit,
                                  })
                                  // Registered limit is sufficient, skip E_MANDATE
                                  // next(2) skips Step 1
                                  next(2, res.data.updateUser)
                                }
                              })
                              .catch((stepErr) => {
                                console.error('Error completing step:', stepErr)
                                next(
                                  isNewAuaAdvisoryGenerate ? 1 : 2,
                                  res.data.updateUser
                                )
                              })
                              .catch(async (stepErr) => {
                                console.error(
                                  "Error completing step:",
                                  stepErr
                                );
                                next(
                                  isNewAuaAdvisoryGenerate ? 1 : 2,
                                  res.data.updateUser
                                );
                              });
                          })
                          .catch(async (err) => {
                            console.error(
                              "Error updating user to AGREEMENT_SIGN:",
                              err
                            );
                            next(1, res.data.updateUser);
                          });
                      } else {
                        // Original/parent user flow: follow normal Agreement -> E-Mandate decision.
                        if (totalNetAmount > 0 && registeredLimit < totalNetAmount) {
                          console.log('E_MANDATE_DECISION_INVESTMENT_PLANNING_NO_ADDON_SKIP', {
                            userId: currentUser?.id,
                            decision: 'SHOW_E_MANDATE',
                            totalNetAmount,
                            compareMandateAmount: registeredLimit,
                          })
                          // New mandate amount is larger, proceed normally to Agreement Sign (then E_MANDATE)
                          next(1, res.data.updateUser)
                        } else {
                          console.log('E_MANDATE_DECISION_INVESTMENT_PLANNING_NO_ADDON_SKIP', {
                            userId: currentUser?.id,
                            decision: 'SKIP_E_MANDATE',
                            totalNetAmount,
                            compareMandateAmount: registeredLimit,
                          })
                          // Current mandate amount is sufficient, proceed normally
                          next(1, res.data.updateUser)
                        }
                      }
                    })
                    .catch(async (err) => {
                      console.error("Error fetching UserAddons:", err);
                      next(1, res.data.updateUser);
                    });
                });
            });
        })
        .catch(async (err) => {
          setLoader(false);
          dispatch({ type: "IS_ACCEPT_LOADING", data: false });
          dispatch({ type: "IS_RESUBMIT_LOADING", data: false });
          console.log(err);
        });
    });
  };

  const handleAgree = (e) => {
    setAgree(e.target.checked);
  };

  const reviewPlanSection = reviewPlanData ? (
    <div>
      {isFinRakshak ? (
        <Table
          className="review-plan-data-table investment-planning"
          dataSource={finRakshakRows}
          columns={finRakshakColumns}
          pagination={false}
          style={{
            padding: isMobile ? "8px" : "16px",
          }}
        />
      ) : (
        <>
          {!isFinsaver && (
            <>
              <Table
                className="review-plan-data-table investment-planning"
                dataSource={reviewPlanSummaryRows}
                columns={Columns}
                pagination={false}
                style={{
                  padding: isMobile ? "8px" : "16px",
                }}
              />
              <br />
            </>
          )}
          <Table
            className="review-plan-data-table"
            dataSource={reviewPlanAnnualisedRows}
            columns={newColumns}
            pagination={false}
            style={{
              padding: isMobile ? "8px" : "16px",
            }}
          />
        </>
      )}
      <div>
        <div className="agree-wrapper aua-verification">
          <Checkbox onChange={handleAgree} checked={agree} />
          <p className="agree-content">
            I/We hereby declare that the details furnished above are true and
            correct to the best of my/our knowledge and belief and I/We
            undertake to inform you of any changes therein, immediately. In
            case any of the above information is found to be false or untrue or
            misleading or misrepresenting, I am/We are aware that I/We may be
            held liable for it.
          </p>
        </div>

        <Button
          id="btn-click"
          style={{
            display: "none",
          }}
          type="primary"
          disabled={!agree}
          loading={planLoader}
          onClick={() => planMail()}
        >
          Yes and Next
        </Button>
      </div>
    </div>
  ) : null;

  const handlePortfolioFileChange = (event) => {
    const selectedFiles = Array.from(event?.target?.files || []);

    if (!selectedFiles.length) {
      return;
    }

    setPortfolioFiles((currentFiles) => {
      const nextFiles = new Map(
        currentFiles.map((file) => [getPortfolioFileKey(file), file])
      );

      selectedFiles.forEach((file) => {
        nextFiles.set(getPortfolioFileKey(file), file);
      });

      return Array.from(nextFiles.values());
    });
    setPortfolioError("");
    setPortfolioResult([]);
    setPortfolioFileUploads([]);
    setReviewPlanData(undefined);

    if (portfolioPollingIntervalRef.current) {
      clearInterval(portfolioPollingIntervalRef.current);
      portfolioPollingIntervalRef.current = null;
    }

    if (event?.target) {
      event.target.value = "";
    }
  };

  const handlePortfolioFileRemove = (fileKeyToRemove) => {
    setPortfolioFiles((currentFiles) =>
      currentFiles.filter(
        (currentFile) => getPortfolioFileKey(currentFile) !== fileKeyToRemove
      )
    );
    setPortfolioError("");
    setPortfolioResult([]);
    setPortfolioFileUploads([]);
    setReviewPlanData(undefined);

    if (portfolioPollingIntervalRef.current) {
      clearInterval(portfolioPollingIntervalRef.current);
      portfolioPollingIntervalRef.current = null;
    }

    if (portfolioFileInputRef.current) {
      portfolioFileInputRef.current.value = "";
    }
  };

  const startPollingPortfolioBeta = (processId) => {
    if (portfolioPollingIntervalRef.current) {
      clearInterval(portfolioPollingIntervalRef.current);
    }

    setPortfolioCalculationLoading(true);
    setPortfolioError("");

    const checkCalculation = async () => {
      try {
        const response = await client.query({
          query: GET_PORTFOLIO_BETA,
          variables: {
            where: {
              valuationDate: portfolioValuationDate || null,
              amountToShift: portfolioAmountToShift
                ? parseInt(portfolioAmountToShift, 10)
                : null,
              processId: processId ? parseInt(processId, 10) : null,
            },
          },
          fetchPolicy: "network-only",
        });

        const portfolioData = response?.data?.getPortfolioBeta || [];

        if (portfolioData && portfolioData.length > 0) {
          if (portfolioPollingIntervalRef.current) {
            clearInterval(portfolioPollingIntervalRef.current);
            portfolioPollingIntervalRef.current = null;
          }

          setPortfolioResult(portfolioData);

          const totalExposure = parsePortfolioNumber(
            getPortfolioSummary(portfolioData)?.totalValue
          );

          if (!currentUserPlanId) {
            setPortfolioError("Unable to find the selected FinRakshak plan.");
            setPortfolioCalculationLoading(false);
            return;
          }

          if (!totalExposure) {
            setPortfolioError(
              "Unable to determine portfolio total value for the AMC calculation."
            );
            setPortfolioCalculationLoading(false);
            return;
          }

          setExposureValue(totalExposure);
          form.setFieldsValue({
            plan: Number.parseInt(String(currentUserPlanId), 10),
            udInvestment: portfolioAmountToShift
              ? parseInt(portfolioAmountToShift, 10)
              : initialInvestment,
          });

          const reviewPlanResponse = await client.query({
            query: GET_SP_AUTO_ADVISE,
            variables: {
              where: {
                dontBuyEquity: "NO",
                exposure: parseInt(totalExposure, 10),
                planId: Number.parseInt(String(currentUserPlanId), 10),
                udInvestment: portfolioAmountToShift
                  ? parseInt(portfolioAmountToShift, 10)
                  : initialInvestment,
                source:
                  currentUser?.role !== "CLIENT"
                    ? `${currentUser?.firstName} ${currentUser?.lastName} (${currentUser?.role})`
                    : window?.location?.pathname === "/add-aua-verification"
                      ? "ADD AUA"
                      : window?.location?.pathname === "/pending-advisory"
                        ? "Pending Advisory"
                        : "Onboarding",
              },
            },
            fetchPolicy: "network-only",
          });

          setReviewPlanData(reviewPlanResponse?.data?.spAutoAdvise);
          setPortfolioCalculationLoading(false);
        }
      } catch (portfolioCalculationError) {
        console.log("Polling error:", portfolioCalculationError);
      }
    };

    checkCalculation();
    portfolioPollingIntervalRef.current = setInterval(checkCalculation, 5000);
  };

  const handlePortfolioUpload = async () => {
    if (!portfolioFiles.length) {
      setPortfolioError("Please choose at least one portfolio file before uploading.");
      return;
    }

    try {
      setPortfolioUploadLoading(true);
      setPortfolioError("");

      const response = await client.mutate({
        mutation: UPLOAD_PORTFOLIO_BETA_FILE,
        variables: {
          files: portfolioFiles,
          strategyCode: PORTFOLIO_BETA_STRATEGY_CODE,
          valuationDate: portfolioValuationDate || null,
          amountToShift: portfolioAmountToShift
            ? parseInt(portfolioAmountToShift, 10)
            : null,
        },
      });

      const uploadedFile = response?.data?.uploadPortfolioBetaFile;
      const processId = uploadedFile?.processId;


      const uploadedUrls = Array.isArray(uploadedFile?.urls)
        ? uploadedFile.urls
        : typeof uploadedFile?.url === "string" && uploadedFile.url
          ? uploadedFile.url
            .split(",")
            .map((url) => url.trim())
            .filter(Boolean)
          : []

      if (!uploadedUrls.length) {
        throw new Error("Portfolio upload failed");
      }

      const uploadedFiles = portfolioFiles.map((currentFile, index) => ({
        name: currentFile.name,
        url: uploadedUrls[index] || "",
      }));

      setPortfolioFileUploads(uploadedFiles);

      if (processId) {
        startPollingPortfolioBeta(processId);
      }

      openNotification(
        "success",
        `${uploadedFiles.length} portfolio file${uploadedFiles.length > 1 ? "s were" : " was"
        } uploaded successfully`
      );
    } catch (portfolioUploadError) {
      console.log(portfolioUploadError);
      setPortfolioError(
        portfolioUploadError?.message ||
        "Unable to upload the portfolio files right now."
      );
    } finally {
      setPortfolioUploadLoading(false);
    }
  };



  const portfolioFileSelectionLabel =
    portfolioFiles.length === 0
      ? "Select CSV, XLS or XLSX files"
      : `${portfolioFiles.length} file${portfolioFiles.length > 1 ? "s" : ""} selected`;


  if (isPortfolioBetaFlow) {
    return (
      <>
        <Row className="row-style">
          <Col
            lg={
              !isNewAuaAdvisoryGenerate && currentUser?.completedSteps !== "DONE"
                ? 16
                : 24
            }
            sm={24}
            className={`${!isNewAuaAdvisoryGenerate && currentUser?.completedSteps !== "DONE"
              ? "col-left risk-profile-col"
              : "risk-profile-col"
              }? `}
          >
            <div>
              <CustomMeta title="Investment Planning" />
              {currentUser?.completedSteps === "DONE" && (
                <div style={{ marginBottom: "20px", padding: "16px" }}>
                  <Row>
                    <Col span={24}>
                      <div style={{ marginBottom: "12px", fontWeight: "600" }}>
                        Select Plan Type
                      </div>
                      <Radio.Group
                        value={selectedPlanType}
                        onChange={(e) => {
                          setSelectedPlanType(e.target.value);
                          if (e.target.value === "active") {
                            setSelectedNewPlan();
                          }
                        }}
                        style={{ width: "100%" }}
                      >
                        <Row gutter={16}>
                          <Col span={12}>
                            <Radio
                              value="active"
                              style={{ fontSize: "16px", fontWeight: "500" }}
                            >
                              Active Plan
                            </Radio>
                          </Col>
                          <Col span={12}>
                            <Radio
                              value="new"
                              style={{ fontSize: "16px", fontWeight: "500" }}
                            >
                              Select New Plan
                            </Radio>
                          </Col>
                        </Row>
                      </Radio.Group>
                    </Col>
                  </Row>
                </div>
              )}

              {selectedPlanType === "active" && (
                <Form form={form} component={false}>
                  <FormItem name="plan" hidden>
                    <Input />
                  </FormItem>
                  <FormItem name="udInvestment" hidden>
                    <Input />
                  </FormItem>
                  {(selectedPlanType === 'new' || (!parentUserId && completedSteps !== 'DONE')) && (
                    <div className='assessment-details-box' style={{ marginBottom: '24px' }}>
                      <FormItem label='Select Advisory Type' required style={{ marginBottom: '0' }}>
                        <Select
                          style={{ width: '100%' }}
                          className='display-field'
                          value={advisoryType}
                          onChange={(val) => {
                            setAdvisoryType(val);
                            setSelectedPlanName(undefined);
                            setSelectedRiskProfile(undefined);
                          }}
                        >
                          <Option value='Index Long Term Strategy'>Index Long Term Strategy</Option>
                          <Option value='FinRakshak - Portfolio Beta Hedging Advisory'>FinRakshak - Portfolio Beta Hedging Advisory</Option>
                          <Option value='FINSaver Advisory - Debt Advisory'>FINSaver Advisory - Debt Advisory</Option>
                        </Select>
                      </FormItem>
                    </div>
                  )}
                  <div className="investment_planning_wrapper portfolio-beta-layout">
                    <div className="portfolio-beta-header">
                      <div className="portfolio-beta-title">
                        Portfolio Beta Calculator
                      </div>
                      <div className="portfolio-beta-subtitle">
                        {portfolioBetaLabel}
                      </div>
                    </div>

                    {!portfolioResult?.length && (
                      <div className="portfolio-beta-form">
                        <div className="portfolio-beta-section">
                          <label className="portfolio-beta-label">
                            Upload Portfolio CSV
                          </label>
                          <div className="portfolio-beta-upload-shell">
                            <div className="portfolio-beta-upload-row">
                              <div className="portfolio-beta-file-input">
                                <input
                                  ref={portfolioFileInputRef}
                                  className="portfolio-beta-hidden-input"
                                  type="file"
                                  multiple
                                  accept=".csv,.xls,.xlsx"
                                  onChange={handlePortfolioFileChange}
                                />
                                <button
                                  type="button"
                                  className="portfolio-beta-picker-button"
                                  onClick={() => portfolioFileInputRef.current?.click()}
                                >
                                  Choose Files
                                </button>
                              </div>
                              <div
                                className={`portfolio-beta-file-status ${portfolioFiles.length ? "has-files" : ""
                                  }`}
                              >
                                {portfolioFileSelectionLabel}
                              </div>
                              <Button
                                type="primary"
                                loading={portfolioUploadLoading}
                                disabled={!portfolioFiles.length}
                                onClick={handlePortfolioUpload}
                                className="yes-next-button portfolio-beta-action-button portfolio-beta-upload-button"
                              >
                                Upload
                              </Button>
                            </div>
                            {portfolioFiles.length > 0 && (
                              <div className="portfolio-beta-file-list">
                                {portfolioFiles.map((file) => {
                                  const fileKey = getPortfolioFileKey(file);

                                  return (
                                    <div
                                      key={fileKey}
                                      className="portfolio-beta-file-pill"
                                    >
                                      <span>{file.name}</span>
                                      <button
                                        type="button"
                                        className="portfolio-beta-file-remove"
                                        onClick={() => handlePortfolioFileRemove(fileKey)}
                                        aria-label={`Remove ${file.name}`}
                                      >
                                        <CloseOutlined />
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                            {portfolioFileUploads.length > 0 && (
                              <div className="portfolio-beta-success-text">
                                {portfolioFileUploads.length} file
                                {portfolioFileUploads.length > 1 ? "s" : ""} uploaded
                                successfully.
                              </div>
                            )}
                          </div>
                        </div>

                        {portfolioCalculationLoading && (
                          <div className="portfolio-beta-actions" style={{ display: "flex", alignItems: "center", gap: "8px", color: "#1890ff", fontWeight: "500", fontSize: "16px", marginTop: "12px", justifyContent: "center" }}>
                            <LoadingOutlined spin />
                            <span>calculate beta in process....</span>
                          </div>
                        )}

                        {portfolioError && (
                          <div className="portfolio-beta-error-text">{portfolioError}</div>
                        )}
                      </div>
                    )}

                    {portfolioResult?.length ? (
                      <div style={{ marginTop: "28px" }}>
                        <div
                          style={{
                            borderTop: "1px solid #d9d9d9",
                            paddingTop: "20px",
                            marginBottom: "18px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "15px",
                              marginBottom: "12px",
                              textTransform: "uppercase",
                            }}
                          >
                            Output
                          </div>
                          <div
                            style={{
                              color: "#237804",
                              fontWeight: 600,
                              marginBottom: "16px",
                            }}
                          >
                            Calculation complete
                          </div>
                          {portfolioSummary?.totalValue !== undefined && (
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              Total Value: ₹
                              {convertNumberToCommaSeparate(
                                Number(portfolioSummary.totalValue) || 0,
                                false
                              )}
                            </div>
                          )}
                          {portfolioSummary?.portfolioBeta !== undefined && (
                            <div style={{ fontSize: "16px", fontWeight: 600 }}>
                              Beta Value: {portfolioSummary.portfolioBeta}
                            </div>
                          )}
                        </div>

                        {portfolioHoldingRows?.length ? (
                          <Table
                            className="review-plan-data-table investment-planning"
                            dataSource={portfolioHoldingRows.map((row, index) => ({
                              key: index,
                              ...row,
                            }))}
                            columns={portfolioColumns}
                            pagination={false}
                            scroll={{ x: true }}
                            style={{
                              width: "100%",
                              padding: 0,
                            }}
                          />
                        ) : null}

                        {isLimitExceeded ? (
                          renderLimitWarningCard()
                        ) : (
                          <>
                            {reviewPlanSection}

                            <div
                              className="verify_next_button"
                              style={{
                                marginRight: "18px",
                                marginTop: "20px",
                                marginBottom: isMobile ? "10dvh" : "2px",
                              }}
                            >
                              <Button
                                className="yes-next-button"
                                type="primary"
                                loading={planLoader}
                                disabled={!reviewPlanData?.length || !agree || errorMessage?.length}
                                onClick={() => planMail()}
                              >
                                Yes and Next
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    ) : null}
                  </div>
                </Form>
              )}

              {selectedPlanType === 'new' && (
                <div className='investment_planning_wrapper' style={{
                  marginTop: '20px'
                }}>
                  <Row className='client-profile-row'>
                    <Col className='gutter-row client-column' lg={24} sm={24}>
                      <div style={{ marginBottom: '16px' }}>
                        <label style={{
                          display: 'block',
                          marginBottom: '8px',
                          fontSize: '14px',
                          fontWeight: '500',
                          color: 'rgba(0, 0, 0, 0.85)'
                        }}>
                          Select your new plan
                        </label>
                        <Select
                          placeholder="Select new plan"
                          getPopupContainer={(trigger) => trigger.parentElement}
                          className="display-field"
                          value={selectedNewPlan}
                          onChange={(value) => {
                            setSelectedNewPlan(value);
                            setReviewPlanData();
                          }}
                          style={{ width: "100%" }}
                        >
                          {newPlanOptions.map((plan) => (
                            <Option key={plan.id} value={plan.id}>
                              {plan.name}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </Col>
                  </Row>
                  <div style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                    <Button
                      id="select-new-plan"
                      className="yes-next-button"
                      type="primary"
                      disabled={!selectedNewPlan}
                      onClick={() => setShowNewPlanModal(true)}
                    >
                      Select New Plan &nbsp;
                      <img src={RightArrowIconWhite} alt="RightArrowIconWhite" />
                    </Button>
                  </div>
                </div>
              )}

              <Modal
                className="Confirm Plan"
                visible={showNewPlanModal}
                footer={null}
                onCancel={() => {
                  setShowNewPlanModal(false);
                  setModalConfirmation();
                }}
              >
                <div>
                  <p>
                    <strong>Selected Plan:</strong>{" "}
                    {(
                      allPlans.find(
                        (p) => String(p?.id) === String(selectedNewPlan)
                      ) ||
                      currentUser?.plan ||
                      missingPlan
                    )?.name || selectedNewPlan}
                  </p>
                  <div style={{ marginTop: "16px" }}>
                    <div style={{ marginBottom: "12px", fontWeight: "600" }}>
                      Do you want to proceed with the selected plan?
                    </div>
                    <Radio.Group
                      value={modalConfirmation}
                      onChange={(e) => setModalConfirmation(e.target.value)}
                    >
                      <Radio
                        value="yes"
                        style={{ display: "block", marginBottom: "8px" }}
                      >
                        Yes, proceed with the new plan
                      </Radio>
                      <Radio
                        value="no"
                        style={{ display: "block", marginBottom: "8px" }}
                      >
                        No, keep the current plan
                      </Radio>
                    </Radio.Group>
                  </div>
                </div>
                <div
                  className="new_kyc_modal_btn"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "8px",
                    marginTop: "16px",
                  }}
                >
                  <Button
                    key="cancel"
                    className="yes-next-button"
                    onClick={() => {
                      if (modalLoading) return;
                      setShowNewPlanModal(false);
                      setModalConfirmation();
                    }}
                    disabled={modalLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    key="submit"
                    type="primary"
                    size="large"
                    className="yes-next-button"
                    style={{ minWidth: "100px" }}
                    loading={modalLoading}
                    onClick={async () => {
                      if (!modalConfirmation) return;
                      if (modalConfirmation === "yes") {
                        try {
                          setModalLoading(true);
                          const res = await client.mutate({
                            mutation: CREATE_USER_FROM_PARENT,
                            variables: {
                              parentId: currentUser?.id,
                              planId: parseInt(selectedNewPlan, 10),
                            },
                          });
                          const payload = res?.data?.createUserFromParent;
                          const token = payload?.token;
                          const user = payload?.user;
                          localStorage.setItem(
                            "onboardingStep",
                            "INVESTMENT_PLANNING"
                          );
                          if (user?.id) {
                            localStorage.setItem("newUserId", user.id);
                          }
                          if (token) {
                            localStorage.setItem("token", JSON.stringify(token));
                            try {
                              await client.resetStore();
                            } catch (e) { }
                          }
                          if (user) {
                            try {
                              dispatch({ type: "CURRENT_USER", data: user });
                            } catch (e) { }
                          }
                          setShowNewPlanModal(false);
                          setModalConfirmation();
                          window.location.href = "/verification";
                        } catch (err) {
                          console.error("Create user failed", err);
                          setShowNewPlanModal(false);
                          setModalConfirmation();
                        } finally {
                          setModalLoading(false);
                        }
                      } else if (modalConfirmation === "no") {
                        setShowNewPlanModal(false);
                        setSelectedPlanType("active");
                        setSelectedNewPlan();
                        setModalConfirmation();
                      }
                    }}
                    disabled={!modalConfirmation || modalLoading}
                  >
                    Submit
                  </Button>
                </div>
              </Modal>
            </div>
          </Col>
          {!isNewAuaAdvisoryGenerate &&
            window.location.pathname === "/verification" &&
            currentUser?.completedSteps !== "DONE" && (
              <Col lg={8} sm={24} className="col-right risk-profile-col">
                <KeyInfo newEdit={newEdit} />
              </Col>
            )}
        </Row>
      </>
    );
  }

  if (!allPlans.length && !currentUserPlanId && !missingPlan) {
    return <h1>Plan not found based on your risk score</h1>;
  }

  return (
    <>
      <Row className="row-style">
        <Col
          lg={
            !isNewAuaAdvisoryGenerate && currentUser?.completedSteps !== "DONE"
              ? 16
              : 24
          }
          sm={24}
          className={`${!isNewAuaAdvisoryGenerate && currentUser?.completedSteps !== "DONE"
            ? "col-left risk-profile-col"
            : "risk-profile-col"
            }? `}
        >
          <div>
            <CustomMeta title="Investment Planning" />

            {/* Plan Type Selection */}
            {currentUser?.completedSteps === "DONE" && (
              <div style={{ marginBottom: "20px", padding: "16px" }}>
                <Row>
                  <Col span={24}>
                    <div style={{ marginBottom: "12px", fontWeight: "600" }}>
                      Select Plan Type
                    </div>
                    <Radio.Group
                      value={selectedPlanType}
                      onChange={(e) => {
                        setSelectedPlanType(e.target.value);
                        if (e.target.value === "active") {
                          setSelectedNewPlan();
                        }
                      }}
                      style={{ width: "100%" }}
                    >
                      <Row gutter={16}>
                        <Col span={12}>
                          <Radio
                            value="active"
                            style={{ fontSize: "16px", fontWeight: "500" }}
                          >
                            Active Plan
                          </Radio>
                        </Col>
                        <Col span={12}>
                          <Radio
                            value="new"
                            style={{ fontSize: "16px", fontWeight: "500" }}
                          >
                            Select New Plan
                          </Radio>
                        </Col>
                      </Row>
                    </Radio.Group>
                  </Col>
                </Row>
              </div>
            )}

            {/* Active Plan Section */}
            {selectedPlanType === "active" && (
              <div className="investment_planning_wrapper">
                {/* <div
                style={{
                  fontSize: '16px',
                  fontWeight: '500',
                  lineHeight: '18.8px',
                  textAlign: 'left',
                  color: '#AF0000',
                  marginBottom: '16px',
                }}
              >
                Note: Kindly fill the data carefully to receive advice
                correctly.
              </div> */}
                <Form
                  form={form}
                  name="register"
                  labelAlign="left"
                  onFinish={onFinish}
                  scrollToFirstError
                  initialValues={{
                    udInvestment: initialInvestment,
                    dontBuyEquity: "YES",
                  }}
                  layout="vertical"
                  className="client-detail-form"
                  style={{ height: "100%" }}
                >
                  <Row className="client-profile-row" gutter={16}>
                    {isSelectionComplete() && (
                      <Col className="gutter-row client-column" lg={12} sm={24}>
                        <FormItem label="How much exposure value do you want to take?">
                          <Input
                            value={convertNumberToCommaSeparate(exposureValue)}
                            placeholder="e.g 10000000"
                            autoFocus={true}
                            style={{
                              width: "100%",
                              textAlign: "right",
                              backgroundColor: "transparent",
                              borderRadius: "8px",
                              marginBottom: "8px",
                              paddingRight: "18px",
                            }}
                            onChange={(e) => {
                              setReviewPlanData();
                              setExposureValue(
                                +e.target.value?.replaceAll(",", "")
                              );
                            }}
                            autoComplete="off"
                            suffix={"₹"}
                          />
                          <span className="wording-text">
                            {numberToWord(Math.round(exposureValue))}
                          </span>
                          <br />
                          <span style={{ color: "red" }}>{errorMessage}</span>
                        </FormItem>
                      </Col>
                    )}

                    <Col className="gutter-row client-column" lg={isSelectionComplete() ? 12 : 24} sm={24}>
                      {!parentUserId && completedSteps !== 'DONE' ? (
                        <div className='assessment-details-box' style={{ marginBottom: '24px' }}>
                          <FormItem label='Select Advisory Type' required style={{ marginBottom: '16px' }}>
                            <Select style={{ width: '100%' }} className='display-field' value={advisoryType} onChange={(val) => { setAdvisoryType(val); setSelectedPlanName(undefined); setSelectedRiskProfile(undefined); setExposureValue(undefined); setReviewPlanData(undefined); }}>
                              {availableAdvisoryTypes.map(type => (
                                <Option key={type} value={type}>{type}</Option>
                              ))}
                            </Select>
                          </FormItem>

                          {advisoryType === 'Index Long Term Strategy' && (
                            <FormItem label='Select Plan' required style={{ marginBottom: '16px' }}>
                              <Select style={{ width: '100%' }} className='display-field' placeholder='Select Plan' value={selectedPlanName} onChange={(val) => { setSelectedPlanName(val); setExposureValue(undefined); setReviewPlanData(undefined); }}>
                                {allPlans
                                  .filter(p => {
                                    const n = p.name.trim().toLowerCase()
                                    return n.includes('basic') || n.includes('relax') || n.includes('power booster') || n.includes('comfort') || n.includes('marathon') || n.includes('index long term strategy')
                                  })
                                  .map(plan => (
                                    <Option key={plan.id} value={plan.name.trim()}>{plan.name}</Option>
                                  ))}
                              </Select>
                            </FormItem>
                          )}

                          {advisoryType === 'FINSaver Advisory - Debt Advisory' && (
                            <FormItem label='Select Risk Profile' required style={{ marginBottom: '16px' }}>
                              <Select style={{ width: '100%' }} className='display-field' placeholder='Select Risk Profile' value={selectedRiskProfile} onChange={(val) => { setSelectedRiskProfile(val); setExposureValue(undefined); setReviewPlanData(undefined); }}>
                                {getRiskProfileOptions().map(opt => (
                                  <Option key={opt} value={opt}>{opt}</Option>
                                ))}
                              </Select>
                            </FormItem>
                          )}
                          <FormItem
                            name='plan'
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: 'Please input your Plan!',
                              },
                            ]}
                          >
                            <Input type="hidden" />
                          </FormItem>

                          <div className='assessment-title' style={{ marginBottom: '8px' }}>Plan Description</div>
                          <div className='assessment-description'>
                            {getPlanDescription()}
                          </div>
                        </div>
                      ) : (
                        <div style={{ marginBottom: '24px' }}>
                          <FormItem
                            label='Your Selected Plan'
                          >
                            <Input
                              style={{ cursor: 'not-allowed' }}
                              readOnly
                              placeholder='Plan'
                              className='display-field'
                              value={
                                currentUser?.plan?.name ||
                                allPlans.find((plan) => String(plan.id) === String(currentUserPlanId))?.name ||
                                missingPlan?.name ||
                                ''
                              }
                            />
                          </FormItem>
                          <FormItem
                            name='plan'
                            noStyle
                            rules={[
                              {
                                required: true,
                                message: 'Please input your Plan!',
                              },
                            ]}
                          >
                            <Input type="hidden" />
                          </FormItem>

                          {(currentUser?.plan?.summary || allPlans.find((plan) => String(plan.id) === String(currentUserPlanId))?.summary || missingPlan?.summary) && (
                            <>
                              <div className='assessment-title' style={{ marginBottom: '8px' }}>Plan Description</div>
                              <div className='assessment-description'>
                                {currentUser?.plan?.summary || allPlans.find((plan) => String(plan.id) === String(currentUserPlanId))?.summary || missingPlan?.summary}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>

                  <div style={{ display: " none" }}>
                    <Button
                      id="review-plan"
                      disabled={errorMessage?.length || !exposureValue}
                      style={{ margin: "0 8px" }}
                      type="primary"
                      htmlType="submit"
                      loading={loader}
                    >
                      Review Plan
                    </Button>
                  </div>
                </Form>

                {isLimitExceeded ? (
                  renderLimitWarningCard()
                ) : (
                  <>
                    {reviewPlanSection}
                    <div
                      className="verify_next_button"
                      style={{
                        marginRight: "18px",
                        marginTop: "20px",
                        marginBottom: isMobile ? "10dvh" : "2px",
                      }}
                    >
                      {!reviewPlanData?.length && (
                        <Button
                          loading={loader}
                          onClick={() => {
                            let ele = document.getElementById("review-plan");
                            ele.click();
                          }}
                          disabled={errorMessage?.length || !exposureValue}
                          className={`${"yes-next-button"}`}
                          style={{
                            background: "#AF0000",
                          }}
                        >
                          Review Plans &nbsp;
                          <img
                            src={RightArrowIconWhite}
                            alt="RightArrowIconBlack"
                          />
                        </Button>
                      )}

                      {reviewPlanData?.length ? (
                        <Button
                          id="btn-click"
                          className="yes-next-button"
                          type="primary"
                          disabled={!agree || errorMessage?.length}
                          loading={planLoader}
                          onClick={() => planMail()}
                        >
                          Yes and Next
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                )}
              </div>
            )}

            {/* New Plan Selection Box - Outside Main Wrapper */}
            {selectedPlanType === 'new' && (
              <div className='investment_planning_wrapper' style={{
                marginTop: '20px'
              }}>
                <Row className='client-profile-row'>
                  <Col className='gutter-row client-column' lg={24} sm={24}>
                    <div className='assessment-details-box' style={{ marginBottom: '24px' }}>
                      <FormItem label='Select Advisory Type' required style={{ marginBottom: '16px' }}>
                        <Select style={{ width: '100%' }} className='display-field' value={advisoryType} onChange={(val) => {
                          setAdvisoryType(val);
                          setSelectedPlanName(undefined);
                          setSelectedRiskProfile(undefined);
                          setSelectedNewPlan(undefined);
                          if (val === 'FinRakshak - Portfolio Beta Hedging Advisory') {
                            const found = newPlanOptions.find(p => p.name.toLowerCase().includes('rakshak') || p.name.toLowerCase().includes('beta')) || newPlanOptions[0];
                            if (found?.id) setSelectedNewPlan(found.id);
                          }
                        }}>
                          {availableAdvisoryTypes.map(type => (
                            <Option key={type} value={type}>{type}</Option>
                          ))}
                        </Select>
                      </FormItem>

                      {advisoryType === 'Index Long Term Strategy' && (
                        <FormItem label='Select Plan' required style={{ marginBottom: '16px' }}>
                          <Select style={{ width: '100%' }} className='display-field' placeholder='Select Plan' value={selectedPlanName} onChange={(val) => {
                            setSelectedPlanName(val);
                            const found = allPlans.find(p => p.name.trim().toLowerCase() === val.trim().toLowerCase());
                            setSelectedNewPlan(found?.id);
                          }}>
                            {newPlanOptions
                              .filter(p => {
                                const n = p.name.trim().toLowerCase()
                                const activeName = (currentUser?.plan?.name || '').trim().toLowerCase()
                                const isMatchesActive = activeName && n === activeName
                                return (n.includes('basic') || n.includes('relax') || n.includes('power booster') || n.includes('comfort') || n.includes('marathon') || n.includes('index long term strategy')) && !isMatchesActive
                              })
                              .map(plan => (
                                <Option key={plan.id} value={plan.name.trim()}>{plan.name}</Option>
                              ))}
                          </Select>
                        </FormItem>
                      )}

                      {advisoryType === 'FINSaver Advisory - Debt Advisory' && (
                        <FormItem label='Select Risk Profile' required style={{ marginBottom: '16px' }}>
                          <Select style={{ width: '100%' }} className='display-field' placeholder='Select Risk Profile' value={selectedRiskProfile} onChange={(val) => {
                            setSelectedRiskProfile(val);
                            const found = newPlanOptions.find(p => p.name.trim().toLowerCase() === val.trim().toLowerCase() || p.name.trim().toLowerCase().includes(val.trim().toLowerCase()));
                            if (found?.id) {
                              setSelectedNewPlan(found.id);
                            }
                          }}>
                            {newPlanOptions
                              .filter(p => {
                                const n = p.name.trim().toLowerCase()
                                const activeName = (currentUser?.plan?.name || '').trim().toLowerCase()
                                const isMatchesActive = activeName && (n === activeName || activeName.includes(n) || n.includes(activeName))

                                const allowedProfiles = getRiskProfileOptions().map(opt => opt.toLowerCase())
                                const isRiskScoreAllowed = allowedProfiles.some(opt => n.includes(opt) || opt.includes(n))

                                return (n.includes('conservative') || n.includes('moderate') || n.includes('aggressive')) && isRiskScoreAllowed && !isMatchesActive
                              })
                              .map(plan => (
                                <Option key={plan.id} value={plan.name.trim()}>{plan.name}</Option>
                              ))}
                          </Select>
                        </FormItem>
                      )}

                      <div className='assessment-title' style={{ marginBottom: '8px' }}>Plan Description</div>
                      <div className='assessment-description'>
                        {allPlans.find(p => String(p.id) === String(selectedNewPlan))?.summary || getPlanDescription()}
                      </div>
                    </div>
                  </Col>
                </Row>
                <div style={{
                  marginTop: '16px',
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                  <Button
                    id="select-new-plan"
                    className="yes-next-button"
                    type="primary"
                    disabled={!selectedNewPlan}
                    onClick={() => setShowNewPlanModal(true)}
                  >
                    Select New Plan &nbsp;
                    <img src={RightArrowIconWhite} alt="RightArrowIconWhite" />
                  </Button>
                </div>
              </div>
            )}

            {/* New Plan Confirmation Modal */}
            <Modal
              className="Confirm Plan"
              visible={showNewPlanModal}
              footer={null}
              onCancel={() => {
                setShowNewPlanModal(false);
                setModalConfirmation();
              }}
            >
              <div>
                <p>
                  <strong>Selected Plan:</strong>{" "}
                  {(
                    allPlans.find(
                      (p) => String(p?.id) === String(selectedNewPlan)
                    ) ||
                    currentUser?.plan ||
                    missingPlan
                  )?.name || selectedNewPlan}
                </p>
                <div style={{ marginTop: "16px" }}>
                  <div style={{ marginBottom: "12px", fontWeight: "600" }}>
                    Do you want to proceed with the selected plan?
                  </div>
                  <Radio.Group
                    value={modalConfirmation}
                    onChange={(e) => setModalConfirmation(e.target.value)}
                  >
                    <Radio
                      value="yes"
                      style={{ display: "block", marginBottom: "8px" }}
                    >
                      Yes, proceed with the new plan
                    </Radio>
                    <Radio
                      value="no"
                      style={{ display: "block", marginBottom: "8px" }}
                    >
                      No, keep the current plan
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
              <div
                className="new_kyc_modal_btn"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "8px",
                  marginTop: "16px",
                }}
              >
                <Button
                  key="cancel"
                  className="yes-next-button"
                  onClick={() => {
                    if (modalLoading) return;
                    setShowNewPlanModal(false);
                    setModalConfirmation();
                  }}
                  disabled={modalLoading}
                >
                  Cancel
                </Button>
                <Button
                  key="submit"
                  type="primary"
                  size="large"
                  className="yes-next-button"
                  style={{ minWidth: "100px" }}
                  loading={modalLoading}
                  onClick={async () => {
                    if (!modalConfirmation) return;
                    if (modalConfirmation === "yes") {
                      try {
                        setModalLoading(true);
                        const res = await client.mutate({
                          mutation: CREATE_USER_FROM_PARENT,
                          variables: {
                            parentId: currentUser?.id,
                            planId: parseInt(selectedNewPlan, 10),
                          },
                        });
                        const payload = res?.data?.createUserFromParent;
                        const token = payload?.token;
                        const user = payload?.user;
                        // set onboarding step for new user
                        localStorage.setItem(
                          "onboardingStep",
                          "INVESTMENT_PLANNING"
                        );
                        if (user?.id) {
                          localStorage.setItem("newUserId", user.id);
                        }
                        if (token) {
                          // overwrite current token (logs out previous user)
                          localStorage.setItem("token", JSON.stringify(token));
                          // reset apollo store to avoid cached old user data
                          try {
                            await client.resetStore();
                          } catch (e) { }
                        }
                        // update current user in app state if available
                        if (user) {
                          try {
                            dispatch({ type: "CURRENT_USER", data: user });
                          } catch (e) { }
                        }
                        setShowNewPlanModal(false);
                        setModalConfirmation();
                        // redirect to verification onboarding page
                        window.location.href = "/verification";
                      } catch (err) {
                        console.error("Create user failed", err);
                        setShowNewPlanModal(false);
                        setModalConfirmation();
                      } finally {
                        setModalLoading(false);
                      }
                    } else if (modalConfirmation === "no") {
                      setShowNewPlanModal(false);
                      setSelectedPlanType("active");
                      setSelectedNewPlan();
                      setModalConfirmation();
                    }
                  }}
                  disabled={!modalConfirmation || modalLoading}
                >
                  Submit
                </Button>
              </div>
            </Modal>
          </div>
        </Col>
        {!isNewAuaAdvisoryGenerate &&
          window.location.pathname === "/verification" &&
          currentUser?.completedSteps !== "DONE" && (
            <Col lg={8} sm={24} className="col-right risk-profile-col">
              <KeyInfo newEdit={newEdit} />
            </Col>
          )}
      </Row>
    </>
  );
};

export default InvestmentPlanningNew;
